import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.468 43.855a1 1 0 0 1-.862-1.805A20 20 0 0 0 46 23.991 20 20 0 0 0 34.547 5.904a1 1 0 0 1 .856-1.808A22 22 0 0 1 48 23.991a22 22 0 0 1-12.532 19.864Zm-1.846-4.65a1 1 0 1 1-1.07-1.689A15.985 15.985 0 0 0 40 23.991a15.986 15.986 0 0 0-7.56-13.596 1 1 0 0 1 1.056-1.698c5.246 3.264 8.504 9 8.504 15.294a17.985 17.985 0 0 1-8.377 15.215Zm-3.315-5.164a1 1 0 0 0 1.414.025A13.96 13.96 0 0 0 36 23.991a13.96 13.96 0 0 0-4.354-10.146 1 1 0 0 0-1.378 1.449A11.96 11.96 0 0 1 34 23.99a11.96 11.96 0 0 1-3.668 8.636 1 1 0 0 0-.025 1.414Zm-21.28-2.054a7 7 0 0 1-6.99-6.623 25.534 25.534 0 0 1 0-2.755 7 7 0 0 1 6.99-6.622h3.48l1.542-1.736a60.546 60.546 0 0 1 7.396-7.03l1.101-.883a3 3 0 0 1 4.864 2.066c.394 4.278.59 9.471.59 15.583 0 6.11-.196 11.302-.59 15.579a3 3 0 0 1-4.866 2.064l-1.152-.926a61.113 61.113 0 0 1-7.49-7.139l-1.397-1.578H9.027Z",
    fill: "currentColor"
  }));
};

var SvgSoundHigh = styled(SvgComponent).withConfig({
  displayName: "SoundHigh__SvgSoundHigh",
  componentId: "sc-cghtgw-0"
})(["", " ", ""], size, color);
export default SvgSoundHigh;